<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input
        size="medium"
        v-model="searchForm.nodeNumber"
        placeholder="请输入节点名称"
        @keyup.enter.native="getTableList"
      ></el-input>
      <!-- <el-input size="medium" v-model="searchForm.key_words" placeholder="请输入搜索内容"  @keyup.enter.native="getTableList"></el-input> -->
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/nodeProductAccount/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
        <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      width="120"
      prop="date"
      label="时间">
    </el-table-column>
    <el-table-column
      prop="nodeNumber"
      label="节点名称">
    </el-table-column>
    <el-table-column
      prop="powerGrowth"
      label="当日新增算力(TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.powerGrowth,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="unitPledge"
      width="160px"
      label="单TiB质押币(FIL/TiB)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.unitPledge,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="unitProductGas"
      label="单TiB生产Gas消耗">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.unitProductGas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="newPledge"
      width="140px"
      label="当日新增质押币">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.newPledge,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="productGas"
      label="当日生产Gas消耗">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.productGas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="190px"
      prop="totalGas"
      label="合计(当日质押+生产Gas)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.totalCost,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="burn"
      width="160px"
      label="FIL/USDT平均价格">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.filUsdt,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="burn"
      width="130px"
      label="USDT/CNY汇率">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.usdtCny,4)}}</span>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        nodeNumber: null,
        startTime:'',
        endTime:'',
      },
      tableData: [],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.nodePowerDaily({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
